<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand custom-font-nav" href="#">
        <strong> <i class="fa fa-home mr-1"></i>MY MUIC /</strong> {{routeName}} 
        <!-- {{ $keycloak.fullName }} -->
      </a>
      <button class="navbar-toggler navbar-burger"
              type="button"
              @click="toggleSidebar"
              :aria-expanded="$sidebar.showSidebar"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <!-- <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-user"></i>
              <p>{{ $store.state.auth.status }}</p>
            </a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </a>
          </li>
          <drop-down class="nav-item"
                     title="5 Notifications"
                     title-classes="nav-link"
                     icon="ti-bell">
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-settings"></i>
              <p>
                Settings
              </p>
            </a>
          </li>
        </ul>
      </div> -->
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <!-- 
            <drop-down 
              class="nav-item"
              :title="$keycloak.fullName"
              title-classes="nav-link"
              icon="fa fa-user-circle-o"
            >
              <a class="dropdown-item" :href="$keycloak.createLogoutUrl()"><i class="fa fa-sign-out"></i>Log out</a>
            </drop-down> 
          -->
          <b-dropdown
            split
            split-variant="link"
            variant="dark"
            class="nav-item"
            size="sm"
          >
            <template #button-content>
              <b-media class="text-dark mb-0">
                <template #aside>
                  <img v-if="imageView !== ''" :src="imageView" style="width:40px;height:40px;" class="align-middle rounded-circle img-responsive" alt="avatar.png">
                  <img v-else style="width:40px;height:40px;" src="@/assets/img/avatar.png"  class="align-middle rounded-circle"  alt="avatar.png">
                </template>
                <p class="text-capitalize custom-font-nav float-center mt-0 mb-1">{{ $keycloak.fullName }}</p>
                <h6 class="custom-font-nav text-muted float-left mt-0 mb-0">MUIC Account : {{ $keycloak.userName }}</h6>
              </b-media>
            </template>
            <b-dropdown-text style="width: 250px;">
              <p class="custom-font-nav mt-2 mb-0"><span class="text-muted">E-mail</span> : {{ $keycloak.tokenParsed.email }}</p>
            </b-dropdown-text>
            <b-dropdown-item to="/profile"><span class="font-weight-bold"><i class="ti-user"></i>My Profile</span></b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item class="custom-font-nav" :href="$keycloak.createLogoutUrl()"><span class="font-weight-bold text-danger"><i class="fa fa-sign-out"></i>Log out</span></b-dropdown-item>
          </b-dropdown>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    computed: {
      routeName() {
        const { name } = this.$route;
        return this.capitalizeFirstLetter(name);
      }
    },
    data() {
      return {
        imageView:'',
        successcus:'#4e4376',
        activeNotifications: false
      };
    },
    mounted(){
        this.readPhotoFile()
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      ImageProfile(val) { return val !== null && val !== 'null' ? val : `@/assets/img/avatar.png` },
      async readPhotoFile(){
          try {
              const res = await this.$http.get(`/portal/profile/get_img/`,{ 'responseType': 'blob' }).then((res) => {
                  if(res.status === 200){
                      let blob = new Blob([res.data])
                      return this.imageView = this.ImageProfile(window.URL.createObjectURL(blob))
                  }else{
                      throw { res }
                  }
              })
          } catch (error) {
              return this.imageView = ''
          }
      },
    }
  };
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Balsamiq+Sans&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@600&display=swap');
  .custom-font{
    // font-family: 'Balsamiq Sans', cursive;
    font-family: 'Nunito', sans-serif;
    font-weight: 100;
  }
  .custom-font-nav{
    // font-family: 'Balsamiq Sans', cursive;
    font-family: 'Nunito', sans-serif;
  }
  .font-en{ font-family: 'Rubik', sans-serif; }
</style>